module.exports = __webpack_public_path__ + "img/conny-stage4-hungry.c5d8ae73.png";